import { TravelTypes } from '../constants';

const formatTravelMode = (mode) => (mode === TravelTypes.carrental ? 'rental car' : Object.keys(TravelTypes)[mode]);

export default formatTravelMode;
